<template>
    <div class="box">
        <div class="top">健康记录</div>
        <div class="slider"></div>
        <div class="content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="健康信息" name="a">
                    <div>
                        <div class="slider contain">基本信息</div>
                        <el-form ref="form" :model="form" label-width="80px">
                            <el-form-item label="事业群">
                                <el-input v-model="form.cldgroup" placeholder="请输入事业群" ></el-input>
                            </el-form-item>
                            <el-form-item label="部门">
                                <el-input v-model="form.department" placeholder="请输入部门" ></el-input>
                            </el-form-item>
                            <el-form-item label="姓名">
                                <el-input v-model="form.name" placeholder="请输入姓名" ></el-input>
                            </el-form-item>
                            <el-form-item label="手机号">
                                <el-input v-model="form.telephone" placeholder="请输入手机号码" @blur="judgePhone"></el-input>
                            </el-form-item>
                            <el-form-item label="打卡日期">
                                <el-input v-model="form.datetime" ></el-input>
                            </el-form-item>
                            <el-form-item label="返回工作地日期">
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="选择日期" v-model="form.returndate" style="width: 100%;"></el-date-picker>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="健康状况">
                                <el-select v-model="form.health" placeholder="请选择">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>


                            </el-form-item>
                            <el-divider content-position="center">我是分割线</el-divider>

                        <div class="slider contain">每日日报</div>
                        <div class="daily">
                            <div class="paper">
                                今日完成：
                                <textarea placeholder="任务内容" v-model="form.todaytask"></textarea>
                            </div>
                            <div class="paper">
                                明日任务：
                                <textarea placeholder="任务内容" v-model="form.tomorrowtask"></textarea>
                            </div>
                        </div>
                        <div class="buttonPrimary">
                            <button @click="submit()">提 交</button>
                        </div>
                        </el-form>
                    </div>

                </el-tab-pane>
                <el-tab-pane label="查看" name="b">

                </el-tab-pane>
            </el-tabs>
        </div>

    </div>
</template>

<script>

    import auth from '../api/userauth';

    export default {
        data() {
            return {
                show: false,
                showArea: false,
                showPicker: false,
                showMask: false,
                tID: false,
                tableDisabled: false,
                numIndex: 2,
                dateArea: '',
                form: {
                    name: "",
                    telephone: "",
                    datetime: "",
                    returndate: "",
                    healthdiscribe: "",
                    health: '',
                    todaytask: "",
                    tomorrowtask: "",
                    remark: "",
                    company: '',
                    cldgroup: '',
                    department: '',
                    reporttoperson: '', // '报送人',
                    reporttophone: '' // '报送人电话号码',
                },
                activeName: "a",
                options: [{
                    value: '正常',
                    label: '正常'
                }, {
                    value: '疑似',
                    label: '疑似'
                }, {
                    value: '确诊',
                    label: '确诊'
                }, {
                    value: '异常隔离',
                    label: '异常隔离'
                }, {
                    value: '发烧37.7以上',
                    label: '发烧37.7以上'
                }, {
                    value: '咳嗽',
                    label: '咳嗽'
                }, {
                    value: '感冒不发烧',
                    label: '感冒不发烧'
                }, {
                    value: '发烧37.7以下',
                    label: '发烧37.7以下'
                }, {
                    value: '发烧咳嗽',
                    label: '发烧咳嗽'
                }, {
                    value: '喉咙痛',
                    label: '喉咙痛'
                }, {
                    value: '流涕',
                    label: '流涕'
                }, {
                    value: '鼻塞',
                    label: '鼻塞'
                }, {
                    value: '腹泻',
                    label: '腹泻'
                }, {
                    value: '其他',
                    label: '其他'
                },{
                    value:'痊愈',
                    label:'痊愈'
                }
                ],
                columnsJson: [],
                tableFirst: [
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah']
                ],
                tableSecound: [
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah']
                ],
                tableThird: [
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah']
                ],
                tableFourth: [
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah'],
                    // ['hah', 'haha', 'hah', 'hah']
                ]
            }
        }, mounted() {

            let userstr=sessionStorage.getItem("user");
              userstr="{\"userId\":\"944\",\"name\":\"佟盟\",\"gender\":\"1\",\"mobile\":\"18811733345\"}";
            let user;
            let that = this;
            alert('userstr:'+userstr)
            if(userstr!=null&&userstr!='{}'){
                // alert('has');
                user=JSON.parse(userstr);
                let userId = user.userId;
                this.form.reporttoperson = user.name
                this.form.reporttophone = user.mobile
                this.getFormData()
            }else {
                // alert(' don`t has');

                auth.getCode().then(res => {

                    let data=JSON.stringify(res.data);
                    //alert('data:'+data)
                    if (data!='{}') {
                        sessionStorage.setItem('user', data);
                        let user = JSON.parse(sessionStorage.getItem("user"));
                        let userId = user.userId;
                        this.form.reporttoperson = user.name
                        this.form.reporttophone = user.mobile
                        this.getFormData()
                    } else {
                        this.$message({
                            message: "请在企业微信中打开该页面 ",
                            type: 'error'
                        });
                        this.errorHtml='<div class="el-loading-mask is-fullscreen" style="background-color: rgba(0, 0, 0, 0.7); z-index: 2000;"><div class="el-loading-spinner"><i class="el-icon-loading"></i><p class="el-loading-text">打开此链接的用户,我们很抱歉的通知您,您没有访问此页面的权限</p></div></div>';
                    }


                })
            }

            // 先获取信息
           // this.getCode()

            // this.getFormData()
            //this.getHealth()
        },methods: {
            // 刚哥的数据
            getFormData() {
                this.showMask = true
                let apiurl = 'http://health.sinosoftweixin.com/user/getUser'+'?phone='+this.form.reporttophone
                //let params = '{phone:"'+this.form.reporttophone+'"}';
                alert('apiurl:'+apiurl)
                 this.$http({
                     url: apiurl,
                     method: 'post',
                     params: ''
                    // params: this.$http.adornParams({phone: '13222222222'})
                }).then((data) => {
                    this.showMask = false
                    if(data.data && data.data.code == 200) {
                        alert('data.data :'+data.data )
                        console.log(data.data, '====================getUser')
                        if(data.data.data) {
                            this.form.name = data.data.data.name
                            this.form.telephone = this.form.reporttophone
                            this.form.datetime = data.data.data.recorddate
                            this.form.cldgroup = data.data.data.cldgroup
                            this.form.department = data.data.data.department
                            this.tID = true
                        } else {
                            this.tID = false
                            this.form.datetime = this.getrecordDate()
                            console.log(this.form.datetime)
                        }
                    }
                }).catch((data) => {
                    this.showMask = false
                    console.log(data)
                })
            },
            // 拿到健康状况
            getHealth() {
                this.$http({
                    url: this.$http.adornUrl('/user/getHealthInfo'),
                    method: 'post'
                }).then((data) => {
                    console.log(data)
                    if(data.data && data.data.code == 200) {
                        this.columns = data.data.data.map(v => {
                            return v.codename
                        })
                        this.columnsJson = data.data.data
                    } else {
                       // Toast.fail(data.data.msg)
                    }
                }).catch((data) => {
                    console.log(data)
                })
            },
            // 拿到企业微信的数据
            getUrlParam(name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
                var r = window.location.search.substr(1).match(reg)
                if(r != null) return unescape(r[2])
                return null
            },
            getrecordDate() {
                let date = new Date()
                return `${date.getFullYear()}年${this.notSingle(date.getMonth() / 1 + 1)}月${this.notSingle(date.getDate())}日 ${date.getHours()}:${this.notSingle(date.getMinutes())}:${this.notSingle(date.getSeconds())}`
            },
            notSingle(num) {
                return num > 10 ? num : "0" + num
            },
            formatDate(date) {
                return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
            },
            confirmDate(date) {
                this.show = false
                this.form.returndate = this.formatDate(date)
            },
            onConfirm(value) {
                this.form.health = value
                this.form.healthdiscribe = this.columnsJson.filter(v => v.codename == value)[0].code
                this.showPicker = false
            },
            // 拿到table的数据
            getData(num) {
                this.numIndex = num
            },
            submit() {
                // 判断是否必填已填写
                if(!this.form.telephone) {
                   // Toast.fail('请填写手机号')
                } else if(!this.form.name) {
                    //Toast.fail('请填写姓名')
                } else if(!this.form.healthdiscribe) {
                  //  Toast.fail('请选择健康状况')
                } else if(!this.form.company) {
                   // Toast.fail('请填写事业群-部门')
                } else {
                    this.judgePhone()
                    this.showMask = true
                    this.$http({
                        url: this.$http.adornUrl('/user/insertDaily'),
                        method: 'post',
                        params: this.$http.adornData({
                            dailydata: this.form
                        })
                        // data: this.$http.adornData(this.form)
                    }).then((data) => {
                        this.showMask = false
                        if(data.data && data.data.code == 200) {
                         //   Toast.success(data.data.msg)
                        } else {
                          //  Toast.fail(data.data.msg)
                        }
                    }).catch((data) => {
                        this.showMask = false
                        console.log(data)
                    })
                }
            },
            confirmArea(date) {
                const [start, end] = date
                this.showArea = false
                this.dateArea = `${this.formatDate(start)} - ${this.formatDate(end)}`
            },
            // 判断手机的格式正确
            judgePhone() {
                if(this.form.telephone) {
                    let tt = /^1[3456789]\d{9}$/
                    if(!tt.test(this.form.telephone)) {
                       // Toast.fail('请填写正确格式的手机号')
                        this.form.telephone = ''
                        return
                    }
                }
            }
        }
    }
</script>

<style scoped>
    /* 填表 */

    .daily {
        width: 100%;
        padding: 0.5rem;
        box-sizing: border-box;
    }

    .paper {
        width: 100%;
        height: 8rem;
        border: 1px solid #a9a2a2;
        border-radius: 0.5rem;
        text-align: left;
        padding: 0.3rem;
        box-sizing: border-box;
        margin-bottom: 0.5rem;
    }

    .van-cell>>>.left {
        display: flex;
        justify-content: flex-start;
        width: 110px;
    }

    .van-cell__title,
    .van-cell__value {
        flex: inherit !important;
        text-align: left !important;
        width: 110px !important;
        color: #323233;
    }

    .slider {
        width: 100%;
        height: 0.5rem;
        background: rgb(234, 233, 231);
    }

    .contain {
        height: 3rem;
        display: flex;
        align-items: center;
        padding-left: 0.6rem;
        font-size: 18px;
        box-sizing: border-box;
        color: #6d6c6b;
    }

    textarea {
        border: none;
        width: 100%;
        height: 75%;
    }

    .buttonPrimary {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 0.5rem;
        box-sizing: border-box;
    }

    .buttonPrimary button {
        width: 100%;
        cursor: pointer;
        text-align: center;
        background: #629c64;
        border-color: cadetblue;
        border: none;
        padding: 0.8rem;
        color: #fff;
        font-size: 18px;
        box-sizing: border-box;
        border-radius: 0.3rem;
        padding-left: 0;
        padding-right: 0;
    }

    .top {
        height: 2.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        font-weight: bold;
        background: #fff;
    }

    .content {
        background: #fff;
        /* margin-top: 2.8rem; */
        color: #000;
    }
    /* ---------------查看------------------ */

    .chooseBox {
        width: 100%;
        display: flex;
        justify-content: space-around;
        padding-right: .2rem;
        box-sizing: border-box;
    }

    .area {
        width: 50%;
        align-items: center;
        text-align: left;
        color: #999;
    }

    .currentDate {
        margin-top: .5rem;
        float: right;
        margin-bottom: .5rem;
    }

    .currentDate ul {
        list-style: none;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        background: #8a9a92;
        color: #fff;
        border-radius: .5rem;
        border: 1px solid #a4c3b5;
        overflow: hidden;
    }

    .currentDate ul li {
        padding: .5rem;
        border-right: 1px solid #fff;
    }

    .currentDate ul li.active {
        background: #c99898;
    }

    .currentDate ul li.none {
        border: none;
    }

    .showData {
        width: 98%;
        padding: .2rem;
        box-sizing: border-box;
        border-collapse: collapse;
    }

    .showData tr {
        border: none;
        font-size: 14px;
    }

    .showData tr:nth-of-type(1) {
        background: #d6d6d6;
    }

    .showData tr td {
        padding: .4rem;
        width: 25%;
        text-align: left;
    }
</style>